import { defineStore } from "pinia";

const DEFAULT_FICHAJES = import.meta.env.PROD
  ? "https://sofyfichajes.sofygest.net/api"
  : "http://10.254.1.204:8070/SofyFichajeApi/api";

const DEFAULT_MENSAJERIA = import.meta.env.PROD
  ? "https://sofymensajeriaapi.sofygest.net"
  : "http://10.254.1.204:8070/SofyRecursosHumanosApi";

export const useApiStore = defineStore("apiStore", {
  state: () => ({
    apiUrl: "", // Almacena la URL proporcionada por el usuario
    apiFichajesUrl: DEFAULT_FICHAJES, // Almacena la URL de fichajes proporcionada por el usuario
    apiRecursosHumanosUrl: DEFAULT_MENSAJERIA, // Almacena la URL de mensajería proporcionada por el usuario
  }),
  actions: {
    setApiUrl(url: string) {
      this.apiUrl = url;
    },
    setApiFichajesUrl(url: string) {
      this.apiFichajesUrl = url;
    },
    setApiRecursosHumanosUrl(url: string) {
      this.apiRecursosHumanosUrl = url;
    },
  },
  // persistencia
  persist: {
    storage: window.localStorage,
  },
});
